// extracted by mini-css-extract-plugin
export default {"container":"Students_container__T3e3B","preview":"Students_preview__kB2Nj"};